import { render } from "./RealTimeList.vue?vue&type=template&id=c55c8ed0&scoped=true"
import script from "./RealTimeList.vue?vue&type=script&lang=js"
export * from "./RealTimeList.vue?vue&type=script&lang=js"

import "./RealTimeList.vue?vue&type=style&index=0&id=c55c8ed0&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55c8ed0"]])

export default __exports__